/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { ref } from 'ember-ref-bucket';

import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';

export interface BvAppSearchSearchFieldSignature {
  Args: {
    query?: string;
    placeholder?: string;
    onSearch?: (value: string) => void;
    onClear?: () => void;
  };
  Element: HTMLElement;
}

export default class BvAppSearchSearchFieldComponent extends Component<BvAppSearchSearchFieldSignature> {
  @ref('inputNode')
  inputNode: HTMLInputElement | null = null;

  searchId = `${guidFor(this)}BvAppSearchField`;

  @action
  handleClear() {
    this.cleanInput('focus');
  }

  @action
  handleSearch(event: Event) {
    if (!event) {
      return;
    }
    const { currentTarget } = event;
    this.args.onSearch?.((currentTarget as HTMLInputElement)?.value ?? '');
  }

  @action
  focusInput() {
    if (this.inputNode != null) {
      this.inputNode.focus();
    }
  }

  private cleanInput(method: 'focus' | 'blur') {
    if (this.inputNode != null) {
      this.inputNode.value = '';
      this.args.onSearch?.('');
      this.inputNode[method]();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvAppSearch::SearchField': typeof BvAppSearchSearchFieldComponent;
    'bv-app-search/search-field': typeof BvAppSearchSearchFieldComponent;
  }
}
